import { Link as RouterLink, NavLink as RouterNavLink } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { localizedPath } from "@/site";
export function Link({ to, ...props }) {
  const { lang } = useLang();
  return <RouterLink to={localizedPath(to, lang)} {...props} />;
}
export function NavLink({ to, ...props }) {
  const { lang } = useLang();
  return <RouterNavLink to={localizedPath(to, lang)} {...props} />;
}
